export default `
  mutation adminInviteSuperAdmin($email: String!, $firstname: String, $lastname: String) {
    adminInviteSuperAdmin(email: $email, firstname: $firstname, lastname: $lastname) {
      id
      email
      group
      granted
    }
  }
`
